import { lazy } from 'react';

import { formatMessage } from '@/i18n';

import { checkOS } from './tool';

const FaMicrosoft = lazy(() =>
  import('react-icons/fa').then(mod => ({ default: mod.FaMicrosoft }))
);
const FaLinux = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaLinux })));
const FaApple = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaApple })));
const FaLaptop = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaLaptop })));

export const platformMap = [
  {
    id: 0,
    os: formatMessage('system.comm.os.all'),
    icon: FaLaptop,
  },
  {
    id: 1,
    os: 'Windows',
    icon: FaMicrosoft,
    extension: '.exe',
  },
  { id: 2, os: 'Linux', icon: FaLinux, extension: '.deb' },
  { id: 3, os: 'MacOS', icon: FaApple, extension: '.pkg' },
];

export const getCurrentPlatfrom = () => {
  return platformMap.find(p => p.os === checkOS()) || platformMap[0];
};
